import ApiService from '../api.service';
import { FirebaseFunctionNames } from 'core/constants/firebase-function-names';
import {
  IDeliveryRequestCatalogue,
  IDeliveryRequestClearResponse,
  IDeliveryRequestDemoBatchPayload,
  IMailAllowlist,
  IDeliveryRequestSeedPayload,
  IDeliveryRequestSeedResponse,
} from './dev-tools-api-interface';

/**
 * Development-only. The callable refuses outright outside the dev project, so
 * these calls will fail by design if the module is ever reached in production.
 */
const DevToolsApiService = {
  getCatalogue: (): Promise<IDeliveryRequestCatalogue> =>
    ApiService.callFunction<IDeliveryRequestCatalogue>(
      { catalogue: true },
      FirebaseFunctionNames.SEED_DELIVERY_REQUESTS,
    ),

  seedDeliveryRequests: (payload: IDeliveryRequestSeedPayload): Promise<IDeliveryRequestSeedResponse> =>
    ApiService.callFunction<IDeliveryRequestSeedResponse>(payload, FirebaseFunctionNames.SEED_DELIVERY_REQUESTS),

  seedDemoBatch: (payload: IDeliveryRequestDemoBatchPayload): Promise<IDeliveryRequestSeedResponse> =>
    ApiService.callFunction<IDeliveryRequestSeedResponse>(
      { ...payload, demoBatch: true },
      FirebaseFunctionNames.SEED_DELIVERY_REQUESTS,
    ),

  /** Sets up the webhook key, turns forwarding on or off, or replays a submission. */
  jotformRelay: (
    payload:
      | { action: 'generateKey' }
      | { action: 'saveForwarding'; forwardEnabled: boolean; forwardTo: string }
      | { action: 'replay'; uid: string },
  ): Promise<{ ok: boolean; where?: 'cloud' | 'local'; status?: number; error?: string; duplicate?: boolean }> =>
    ApiService.callFunction(payload, FirebaseFunctionNames.DEV_JOTFORM_RELAY),

  mailAllowlist: (): Promise<IMailAllowlist> =>
    ApiService.callFunction<IMailAllowlist>({ action: 'get' }, FirebaseFunctionNames.DEV_MAIL_ALLOWLIST),

  /** Replaces the Dev Tools entries. The deploy workflow's entries are untouched. */
  saveMailAllowlist: (entries: string[]): Promise<IMailAllowlist> =>
    ApiService.callFunction<IMailAllowlist>({ action: 'save', entries }, FirebaseFunctionNames.DEV_MAIL_ALLOWLIST),

  /** Without `confirm` this only counts what would go. */
  clearDeliveryRequests: (confirm: boolean): Promise<IDeliveryRequestClearResponse> =>
    ApiService.callFunction<IDeliveryRequestClearResponse>({ confirm }, FirebaseFunctionNames.CLEAR_DELIVERY_REQUESTS),
};

export default DevToolsApiService;
